// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2C2pD","title":"Info_title__Lhp94","links":"Info_links__2WNni","link":"Info_link__QwAWX","logo":"Info_logo__1wgot"};